import { addNotification } from '../features/notification/slices/notificationSlice';
import { i18n } from '@senderra/translations';
import { NotificationType } from '../features/notification/types';

export const handleQueryStarted = async (_: any, { dispatch, queryFulfilled }: any) => {
    try {
        await queryFulfilled;
    } catch (error: any) {
        const isAbortError = error?.error?.error?.includes('AbortError');
        if (isAbortError) return;
        dispatch(addNotification({ message: i18n.t('common-error-message'), type: NotificationType.ERROR }));
    }
};
